<template>
  <div>
    <!-- header -->
    <Header></Header>

    <!-- intro -->
    <Intro></Intro>

    <!-- con-wrapper-mt -->
    <Content></Content>

    <!-- customer -->
    <Customer></Customer>

    <!-- edu -->
    <Edu></Edu>

    <!-- global partners -->
    <Partners></Partners>

    <!-- program report -->
    <Program></Program>

    <!-- meet the teachers -->
    <Teachers></Teachers>

    <!-- who we are -->
    <Who></Who>

    <!-- ceo -->
    <Ceo></Ceo>

    <!-- culture -->
    <Culture></Culture>

    <!-- inquiry -->
    <Inquiry></Inquiry>

    <!-- footer -->
    <Footer> </Footer>

    <!-- 결제서비스, 문의하기 -->
    <Quick></Quick>

    <!-- <div class="conf-pop-wrapper" v-if="popupOpened">
      <div class="wrapper">
        <div class="inner">
          <div class="content">
            <a
              href="https://conf2024.carrotglobal.com/#history"
              target="_blank"
            >
              <img src="@/assets/img/conf2024/popup2.jpg" alt="img" />
            </a>
            <ul>
              <li><a @click="openPopupFor7Days">7일동안 열지 않기</a></li>
              <li><a @click="closePopup">닫기</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="conf-bottom-banner">
      <a href="https://conf2024.carrotglobal.com/#history" target="_blank">
        <img src="@/assets/img/conf2024/bottom-banner2.jpg" alt="img" />
      </a>
    </div> -->
  </div>
</template>

<script>
import Header from "@/components/NewGlobal/Header.vue";
import Intro from "@/components/NewGlobal/Main/Intro.vue";
import Content from "@/components/NewGlobal/Main/Content.vue";
import Customer from "@/components/NewGlobal/Main/Customer.vue";
import Edu from "@/components/NewGlobal/Main/Edu.vue";
import Partners from "@/components/NewGlobal/Main/Partners.vue";
import Program from "@/components/NewGlobal/Main/Program.vue";
import Teachers from "@/components/NewGlobal/Main/Teachers.vue";
import Who from "@/components/NewGlobal/Main/Who.vue";
import Ceo from "@/components/NewGlobal/Main/Ceo.vue";
import Culture from "@/components/NewGlobal/Main/Culture.vue";
import Inquiry from "@/components/NewGlobal/Inquiry.vue";
import Footer from "@/components/NewGlobal/Footer.vue";
import Quick from "@/components/NewGlobal/Quick.vue";
import "@/assets/style/newGlobalReset.scss";

export default {
  name: "Main",
  components: {
    Header,
    Intro,
    Content,
    Customer,
    Edu,
    Partners,
    Program,
    Teachers,
    Who,
    Ceo,
    Culture,
    Inquiry,
    Footer,
    Quick,
  },
  mounted() {
    this.checkCookie();
  },
  data() {
    return {
      popupOpened: true,
    };
  },
  methods: {
    closePopup() {
      this.popupOpened = false;
    },
    openPopupFor7Days() {
      this.setCookie("popupClosed", "true", 7);
      this.closePopup();
    },
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + "; " + expires + "; path=/";
    },
    getCookie(name) {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.indexOf(name + "=") === 0) {
          return cookie.substring(name.length + 1);
        }
      }
      return "";
    },
    checkCookie() {
      const popupClosed = this.getCookie("popupClosed");
      if (popupClosed === "true") {
        this.popupOpened = false;
      } else {
        this.popupOpened = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.conf-pop-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;

  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    min-height: 100%;

    .inner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: 312px;
      margin: 0 auto;
      background-color: #fff;

      ul {
        display: flex;

        li {
          flex-grow: 1;
          width: 50%;
          padding: 10px;
          text-align: center;
          cursor: pointer;

          &:first-of-type {
            border-right: 1px solid #797979;
          }
        }
      }
    }
  }
}

.conf-bottom-banner {
  display: flex;
  justify-content: center;
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #101010;

  @media screen and (min-width: 1000px) {
    display: none;
  }

  img {
    width: 100%;
    width: 500px;
  }
}
</style>
